export enum TipologiaUtenteEnum {
  AGENZIALE = 1,
  DIREZIONALE = 3
}

// Note: maintain the enum contents as the same in BE service (RuoloUtenteEnum)
export enum RuoloUtenteEnum {
  NOT = "",
  ADMIN = "admin",
  USER = "user",
  SMS_SENDER ="sms_sender",
  ANIA_ADMIN = "ania_admin",
  ANIA_BASE = "ania_base",
  SMS_SENDER_ADMIN = "sms_admin",
  UTENTE_SMART_SUM= "UtenteSmartSum",
  SMART_SUMMARY_ADMIN= "AdminSmartSum"
}
